import { takeEvery, select, put } from 'redux-saga/effects'
import { store } from 'store'
import i18next from 'i18next'

import { getImageToDelete, getImageUsagePlaces } from '../selectors'
import { showError } from '../../toastr/utils'
import { setImageToDelete } from '../actions'
import { modal } from 'store/entities/modal/actions'
import GalleryDeleteImageModal from 'app/components/Modals/ConfirmOrCancel'
import { deleteImageFromGallery } from 'store/entities/gallery/actions'

export default function* deleteImageSaga() {
  yield takeEvery(setImageToDelete, handleDeleteImageRequest)
}

export function* handleDeleteImageRequest() {
  try {
    const image = yield select(getImageToDelete)
    const usagePlaces = yield select(getImageUsagePlaces)
    let text
    if (usagePlaces !== '') {
      text =
        i18next.t('admin:This image used here') +
        '\n' +
        usagePlaces
          .replace(new RegExp('______', 'g'), '<br/><b>')
          .replace(new RegExp('___', 'g'), '</b>')
          .replace(new RegExp('__', 'g'), '<br/>')
    }
    yield put(
      modal.show(GalleryDeleteImageModal, {
        title: i18next.t('admin:Are you sure you want to delete this Image?'),
        dangerouslyText: usagePlaces !== '' ? { __html: text } : null,
        handleSubmit: () => {
          modal.hide()
          store.dispatch(deleteImageFromGallery(image))
        },
        confirmBtn: i18next.t('common:Delete'),
        cancelBtn: i18next.t('common:Cancel'),
        size: 'stretch',
      })
    )
  } catch (error) {
    showError()
  }
}
